import type { PortalModule } from './registry'

export interface PortalTenant {
  /** Microsoft Entra tenant ID (the validated token's `tid` claim). */
  id: string
  name: string
}

export const validTenantId = (id: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)

// `myModules` is what /api/me returns: the visible modules assigned to the signed-in user's tenant.
// These checks only shape the UI; the API enforces the same rules on every request.

export const canUseModule = (module: PortalModule | undefined) => !!module?.visible && !!module.enabled

export const canUse = (myModules: PortalModule[], key: string) => canUseModule(myModules.find((m) => m.key === key))

const routeModules = [
  { path: '/training', key: 'training' },
  { path: '/certificates', key: 'training' },
  { path: '/applications', key: 'applications' },
  { path: '/team', key: 'directory' },
  { path: '/documents', key: 'documents' },
  { path: '/surveys', key: 'surveys' },
]

const pathMatches = (pathname: string, base: string) => pathname === base || pathname.startsWith(`${base}/`)

/** The built-in module that owns a path (including nested pages reached through a shared link). */
export const moduleKeyForPath = (pathname: string) => routeModules.find(({ path }) => pathMatches(pathname, path))?.key

export function canAccessPath(myModules: PortalModule[], pathname: string, isAdmin: boolean) {
  if (pathMatches(pathname, '/manage')) {
    if (!isAdmin) return false
    const managed = pathname.startsWith('/manage/applications') ? 'applications'
      : pathMatches(pathname, '/manage/documents') ? 'documents'
      : pathMatches(pathname, '/manage/surveys') ? 'surveys'
      : pathname.startsWith('/manage/team') ? 'directory'
      : pathname === '/manage' || pathname.startsWith('/manage/trainings') ? 'training'
      : undefined
    return !managed || canUse(myModules, managed)
  }
  const key = moduleKeyForPath(pathname)
  return !key || canUse(myModules, key)
}
